//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SearchResultDocument",
  props: ["result"],
  computed: {
    ...mapGetters(["settings"]),
    ariaLabel() {
      return this.result.title ? "Click to go to " + this.result.title : '';
    },
    lastPublished() {
      const date = new Date(this.result.lastPublished);
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    }
  },
};
